<groundworks-card [cardClasses]="['h-100', 'flex-grow-1']">
  <groundworks-card-header [title]="'Payments'" />
  <groundworks-card-body>
    <div class="d-flex flex-column h-100">
      <div>
        @switch (state()) {
          @case ('loading') {
            <groundworks-state-message type="loading" message="Loading payments..." class="d-flex" />
          }
          @case ('error') {
            <groundworks-state-message type="error" message="Error loading payments." class="d-flex" />
          }
          @case ('no-matches') {
            <groundworks-state-message type="no-matches" message="No job for this opportunity." class="d-flex" />
          }
          @case ('matches') {
            @if (paymentItems().length > 0) {
              <groundworks-term-value [items]="paymentItems()" />
            }
            @if (configService.enablePayments) {
              @if (mergedPaymentGroups().length > 0) {
                @for (group of mergedPaymentGroups(); track $index) {
                  <div [class.fst-italic]="group.isPending" data-testid="payment-group">
                    @for (row of group.rows; track $index) {
                      <groundworks-term-value [items]="row.dateAmountItems" />
                      <div class="d-flex align-items-center gap-2">
                        @if (row.detailLabel) {
                          <div class="payment-detail-label" data-testid="payment-detail-label">{{ row.detailLabel }}</div>
                        }
                        @if (configService.enableEditPayments && canEditPayment && row.editContext) {
                          <button type="button" class="btn btn-sm btn-outline-secondary border-0 p-1"
                                  data-testid="edit-payment"
                                  aria-label="Edit payment"
                                  [disabled]="row.isEditDisabled"
                                  (click)="onEditPayment(row.editContext)">
                            <i class="bi bi-pencil" aria-hidden="true"></i>
                          </button>
                        }
                      </div>
                    }
                  </div>
                }
              }
              <groundworks-term-value [items]="paymentsReceivedItems()" />
              <groundworks-term-value [items]="totalBalanceDueItems()" />
            }
          }
        }
      </div>
      @if (configService.enablePayments) {
        <div class="d-flex justify-content-end mt-auto pt-3">
          <div class="dropdown position-relative" #dropdownRef>
            <button type="button" class="btn btn-sm kebab-toggle p-1"
                    aria-label="More payment actions"
                    [attr.aria-expanded]="isMenuOpen()"
                    aria-haspopup="menu"
                    (click)="toggleMenu()">
              <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>
            </button>
            @if (isMenuOpen()) {
              <div class="dropdown-menu show position-absolute end-0 start-auto" role="menu">
                @if (canPostPayment) {
                <button type="button" class="dropdown-item" role="menuitem"
                        [disabled]="job() === undefined"
                        (click)="onPostPayment()">Post Payment</button>
                }
                <button type="button" class="dropdown-item" role="menuitem"
                        [disabled]="job() === undefined"
                        (click)="onAccountCreditRequest()">Create ACR</button>
                @if (pendingCreditRequests().length > 0) {
                  <button type="button" class="dropdown-item" role="menuitem"
                          (click)="onReviewAcr()">Review ACR</button>
                }
                @if (showStatementActions()) {
                  <button type="button" class="dropdown-item" role="menuitem"
                          (click)="onViewCustomerStatement()">View Customer Statement</button>
                  <button type="button" class="dropdown-item" role="menuitem"
                          [disabled]="isSendingStatement()"
                          (click)="onSendCustomerStatement()">Send Customer Statement</button>
                }
                <button type="button" class="dropdown-item" role="menuitem"
                        data-testid="view-payment-history"
                        (click)="onViewPaymentHistory()">View Payment History</button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </groundworks-card-body>
</groundworks-card>
